import { Owner } from "src/gql/entries/types";

export function getOwnershipProperties(owner: Owner): Record<string, string> {
  switch (owner.type) {
    case "team":
      return { owner_team: owner.handle };
    case "user":
      return { owner_user: owner.handle };
    default:
      return {};
  }
}
